module.exports = __webpack_public_path__ + "img/logout.bdd4ee78.svg";